import React from 'react';
import { BaseCard } from '../../styled';
import { UpcomingActionsWidgetRender } from 'src/pages/DashboardPage/comps/UpcomingActions/UpcomingActions';
import { ActivityData } from 'src/api/types/dashboard';

interface UpcomingActionsProps {
  activityData: ActivityData[];
}

export const UpcomingActions: React.FC<UpcomingActionsProps> = ({ activityData }) => {
  return (
    <BaseCard>
      <span className="c-title">Upcoming Actions</span>
      <UpcomingActionsWidgetRender activityData={activityData} />
    </BaseCard>
  );
};
